import BlockStudents from "components/BlockStudents/BlockStudents";




const BlockStudentsPage: React.FC = () => {
  return <BlockStudents />;
};

export default BlockStudentsPage;